'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/AlertInfo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertInfo = function AlertInfo(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    {
      className: 'alert alert-info cp-alert-info', role: 'alert',
      'aria-live': 'polite', 'aria-atomic': 'true' },
    _react2.default.createElement(_baseIcons.Info, null),
    children
  );
};

AlertInfo.propTypes = {
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
};

exports.default = AlertInfo;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/alerts/lib/components/info/components/AlertInfo.component.js
// module id = 361
// module chunks = 0 1 4